import { Box } from '@chakra-ui/react'
import React from 'react'

function ProfilePage() {
  return (
	<Box height='100vh'>

	</Box>
  )
}

export default ProfilePage